export default __webpack_public_path__ + "static/media/small.1a4f40ef.jpg";